export class DialogSaveAdapter {
    constructor(data) {
        this.newData = { ...data };

        const transformations = {
            files: () => {
                const { files, ...restData } = this.newData;
                this.newData = restData;
                this.newData.files = files
                    ? files.map((file) => {
                        return {
                            id: file.id,
                            merchantFileType: file?.merchantFileType
                        };
                    })
                    : null;
            },
            locationFiles: () => {
                const { locationFiles, ...restData } = this.newData;
                this.newData = restData;
                this.newData.locationFiles = locationFiles
                    ? locationFiles.map((file) => {
                        return {
                            fileId: file.id,
                            merchantLocationFileType:
                                  file?.merchantLocationFileType
                        };
                    })
                    : null;
            },
            merchantFiles: () => {
                const { merchantFiles, ...restData } = this.newData;
                this.newData = restData;
                this.newData.merchantFiles = merchantFiles
                    ? merchantFiles.map((file) => {
                        return {
                            id: file.id,
                            merchantFileType: file?.merchantFileType
                        };
                    })
                    : null;
            },
            file: () => {
                const { file, ...restData } = this.newData;
                this.newData = restData;
                this.newData.filesId = file ? file.id : null;
            },
            coinLogoFilesId: () => {
                const { coinLogoFilesId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.coinLogoFilesId = coinLogoFilesId.length
                    ? coinLogoFilesId.map((file) => file.id)?.[0]
                    : null;
            },
            logoFilesId: () => {
                const isArray = Array.isArray(this.newData.logoFilesId);
                const adaptedFiles = isArray
                    ? this.newData.logoFilesId
                    : [this.newData.logoFilesId];
                const files = adaptedFiles
                    .map((file) => file?.id)
                    .filter(Boolean);
                this.newData.logoFilesId = files.length ? files[0] : null;
            },
            coinId: () => {
                const { coinId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.coinId = coinId || null;
            },
            merchantId: () => {
                const { merchantId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.merchantId = merchantId || null;
            },
            partnersId: () => {
                const { partnersId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.partnersId = partnersId || null;
            },
            merchantLocationsId: () => {
                const { merchantLocationsId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.merchantLocationsId = merchantLocationsId || null;
            },
            categories: () => {
                this.newData.categories = this.newData.categories
                    ? this.newData.categories.map((cat) => cat.id)
                    : null;
            },
            currencyId: () => {
                const { currencyId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.currencyId = currencyId || null;
            },
            owner: () => {
                const { owner, ...restData } = this.newData;
                this.newData = restData;
                const key =
                    restData.kind === 'merchant' ? 'merchantsId' : 'usersId';
                this.newData[key] = owner ? owner.id : null;
            },
            wallets: () => {
                this.newData.wallets = this.newData.wallets && this.newData.wallets.length
                    ? this.newData.wallets
                    : null;
            },
            fromWalletsId: () => {
                const { fromWalletsId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.fromWalletsId = fromWalletsId || null;
            },
            toWalletsId: () => {
                const { toWalletsId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.toWalletsId = toWalletsId || null;
            },
            associatedWalletsId: () => {
                const { associatedWalletsId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.associatedWalletsId = associatedWalletsId || null;
            },
            dateCreated: () => {
                const { dateCreated, ...restData } = this.newData;
                this.newData = restData;
            },
            roleId: () => {
                const { roleId, ...restData } = this.newData;
                this.newData = restData;
                this.newData.roleId = roleId || null;
            },
            role: () => {
                const { role, ...restData } = this.newData;
                this.newData = restData;
                this.newData.roleId = role ? role.id : null;
            },
            allowMinting: () => {
                this.newData.allowMinting = this.newData.allowMinting || false;
            },
            isPublic: () => {
                this.newData.isPublic = this.newData.isPublic || false;
            }
        };

        for (const prop in this.newData) {
            if (transformations[prop]) {
                transformations[prop]();
            }
        }
    }
}
